// @flow

import React from 'react';
import PropTypes from 'prop-types';
import HomeQuery from 'HomeQuery';
import AliasToContentTypeQuery from './AliasToContentTypeQuery';
import StorylineQuery from './StorylineQuery';
import Wheel from './Wheel';

type HomeQueryProps = {
  entity: PropTypes.any.isRequired,
  storyline: PropTypes.any.isRequired,
  loading: PropTypes.bool,
};

const WheelRouter = ({
  entity,
  entities,
  loading,
  storyline,
}: HomeQueryProps): React.Element<any> | null => {
  if (loading) {
    return null;
  }

  return <Wheel {...entity} entities={entities} storyline={storyline} />;
};

export default AliasToContentTypeQuery(StorylineQuery(HomeQuery(WheelRouter)));



// WEBPACK FOOTER //
// ./screens/App/components/Wheel/index.js